<lt-resolved-image
  class="lt-look-image__image"
  [resolved]="resolved()"
  [fallbackSrc]="fallbackSrc()"
  [testId]="testId()"
  [altFallback]="altFallback()"
  [fit]="fit()"
  [focus]="focus()"
  [fill]="fill()"
/>
